import { createSelector } from 'reselect';

const getLoaders = (
  state: import('../types/rootState').RootState
): Record<string, Record<string, string>> => state.loaders;

const isAddingTocart = createSelector(getLoaders, loaders => !!loaders['add-to-bag']);

const isAddingTocartMembership = createSelector(getLoaders, loaders => !!loaders['add-to-bag-membership']);

const isAddingToWishlist = createSelector(getLoaders, loaders => !!loaders['products-loader']);

const fetchingSize = createSelector(getLoaders, loaders => !!loaders['Fetch-size']);

export { getLoaders, isAddingTocart, fetchingSize, isAddingToWishlist, isAddingTocartMembership };
